<template>
	<div class="amount" :style="getProductBgStyle()">
		<div class="title" v-text="productEnum[productType]['name']"></div>
		
		<template v-if='productType == "DFEP"'>
			<div class="install">
				<span class="ep-money">
					<i>MAX</i>
					<span>PHP {{productEnum[productType]['amount']}}</span>
					<img src="./img/epTerm.png" class="nper" />
				</span>
				<img src="./img/epWithdraw.png" class="ep-withdraw" @click="apply" />
			</div>
			
			<p class="unlock-plan">
				<span>Your consistent repayments unlock better plans.</span>
			</p>
		</template>
		
		<template v-else>
			<div class="loan">
				<span>Loan Amount</span>
				<span class="money">PHP {{productEnum[productType]['amount']}}</span>
			</div>
			<a @click="apply">Withdraw</a>
		</template>
		
		<div class="tag" :style="{background:productEnum[productType]['tagBg']}">{{productEnum[productType]['tag']}}</div>
		<!-- 无效产品，并且无在途订单的，置灰 -->
		<div class="mask‌" v-if='productItem.pcStatus != 1 && !(productItem.wpOrderInfoExtend && productItem.wpOrderInfoExtend.orderId)'>
			<img class="lock" src="./img/lock.png"/>
			<div class="tips" v-if="productEnum[productType]['tips']">{{productEnum[productType]['tips']}}</div>
		</div>
	</div>
</template>

<script>
import NP from 'number-precision';
import {productEnum} from './productEnum.js';
export default{
    data(){
        return {
			amount: 5000,
			productEnum
        }
    },
	
	props:{
		userInfo:{
			type:Object,
			default:()=>{}
		},
		productItem:{
			type:Object,
			default:()=>{}
		},
		onTheWayOrder:{
			type:Object,
			default:()=>{}
		},
		productType:{
			type:String,
			default:""
		}
	},
	watch:{
		userInfo:{
			handler(val){
				this.amount = val.amount || 20000;
			},
			immediate: true,
			deep: true
		}
	},

    methods:{
		getProductBgStyle(){
			var config = this.productEnum[this.productType];
			if(config && config.productBg){
				return {
					backgroundImage: 'url(' + config.productBg + ')',
					backgroundSize: '100% 100%',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center'
				};
			}
			return {};
		},
		apply(){
			if(this.userInfo.status == "5"){//进件完成
				if(this.productType == "DFEP"){//分期产品
					location.href = "./fqLoan.html?productType="+this.productType
				}
				else{
					location.href = "./loan.html?productType="+this.productType
				}
			}
			else if(this.userInfo.status == "6"){//注册完成
				if(!(this.onTheWayOrder && this.onTheWayOrder?.status)){//经提交完资料了，无订单
					if(this.productType == "DFEP"){//分期产品
						location.href = "./fqLoan.html?productType="+this.productType
					}
					else{
						location.href = "./loan.html?productType="+this.productType
					}
				}
			}
			else{// 未进件,进件中回调，显示进件入口页面
				location.href = "./infoGuidance.html?productType=" + this.productType + "&status="+this.userInfo.status
			}
		}
    }
}
</script>
<style scoped>
.amount{position: relative;box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);border-radius: 0.2rem;padding: 0.2rem 0.4rem;color: #FF8F1F;background: #fff}
.amount .install{display: flex;align-items: center;justify-content: space-between;margin: 0.2rem 0;}
.install .ep-money{display: flex;align-items: center;color: #3D3D3D;gap: 0 0.12rem;}
.install .ep-money i{line-height: 0.3rem; font-size: 0.24rem; font-style: normal; text-shadow: none;letter-spacing: 0.1em;}
.install .ep-money span{font-size: 0.36rem;font-weight: bold;}
.nper{width: 0.8rem;height: 0.3rem;}
.install .ep-withdraw{width: 1.6rem;}
.amount .title{text-align: center;color:#3D3D3D;font-size: 0.32rem; font-weight: bold;} 
.amount .loan{margin: 0.2rem 0;display: flex;justify-content: space-between;align-items: center;color: #3D3D3D;font-weight: 500;font-size: 0.28rem;}
.amount .money{font-size: 0.36;font-weight: bold;}
.amount a{display: block; margin:0 auto;width:1.6rem;height: 0.5rem;line-height: 0.5rem;font-family: Source Han Sans;text-align: center;font-size: 0.28rem;font-weight: bold;background: #5A6DFF;border-radius:0.4rem; color: #FFF;}
.amount .active{background-color:#667FFB}
.amount .tips{text-align: center;color: #000;font-size:0.20rem;margin-bottom: 0.1rem;}
.amount .tag{position: absolute;top: 0;left: 0;padding: 0 0.1rem;height: 0.36rem;line-height: 0.36rem;color: #fff;font-size: 0.24rem;text-align: center;}
.unlock-plan{text-align: right;font-size: 0.24rem;color: #3D3D3D;}
.unlock-plan span{transform: scale(0.6);display: inline-block;transform-origin: right;}
.mask‌{position:absolute;top:0;bottom:0;left:0;right:0;display: flex;flex-direction: column;justify-content: center;align-items: center;background: rgba(0,0,0,0.3);border-radius: 0.2rem;}
.lock{width: 0.48rem;height: 0.56rem;}
</style>
